<template>
	<!-- 只有当获取到消息数据时才渲染组件 -->
	<div v-if="message" class="message-card fade-in-down">
		<!-- 轮播容器 -->
		<div class="carousel-container">
			<transition name="slide-fade">
				<!-- 图片轮播项 -->
				<div
					v-for="(image, index) in backgroundImages"
					v-show="currentSlideIndex === index"
					:key="'image-' + index"
					class="carousel-slide image-slide"
				>
					<img :src="image" alt="轮播图片" class="slide-image" />
					<!-- <el-image
						:src="image"
						alt="轮播图片"
						class="slide-image"
						fit="contain"
					/> -->
				</div>
			</transition>

			<!-- 消息内容轮播项 -->
			<transition  name="slide-fade">
				<div
					v-show="currentSlideIndex === backgroundImages.length"
					class="carousel-slide message-slide"
				>
					<!-- 装饰背景光晕 -->
					<div class="blob blob-pink"></div>
					<div class="blob blob-blue"></div>

					<div class="card-inner">
						<!-- 左侧图标区域 -->
						<div class="icon-container">
							<div class="icon-circle">
								<fa-icon icon="bell" class="bell-icon" />
							</div>
						</div>

						<!-- 右侧内容区域 -->
						<div class="content-body">
							<div class="meta-info">
								<span class="tag">NEW MESSAGE</span>
								<span class="time"> <fa-icon icon="clock" /> {{ message.time }} </span>
							</div>

							<h2 class="title">{{ message.title }}</h2>

							<p class="description">
								{{ message.description }}
							</p>

							<div class="action-buttons">
								<button class="btn btn-primary" @click="handleWatch"><fa-icon icon="play" class="btn-icon" /> 前往观看</button>
								<button class="btn btn-text" @click="handleRemind">稍后提醒</button>
							</div>
						</div>
					</div>
				</div>
			</transition>
		</div>

		<!-- 轮播指示器 -->
		<div class="carousel-indicators">
			<span
				v-for="(item, index) in totalSlides"
				:key="index"
				class="indicator"
				:class="{ active: currentSlideIndex === index }"
				@click="goToSlide(index)"
			></span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'LatestMessageCard',
	data() {
		return {
			message: null, // 初始为空，接口返回后赋值
			// 背景图片数组 - 你可以在这里手动添加图片路径
			backgroundImages: [
				require('@/assets/images/msg-bg-1.png'),
				// require('@/assets/images/solution-1.jpg'),
				// 在这里添加更多图片路径
				// require('@/assets/images/msg-bg-2.png'),
				// require('@/assets/images/msg-bg-3.png'),
			],
			currentSlideIndex: 0, // 当前显示的轮播索引
			carouselTimer: null, // 轮播定时器
		};
	},
	computed: {
		// 总轮播数 = 图片数量 + 1（消息内容）
		totalSlides() {
			return this.backgroundImages.length + 1;
		}
	},
	created() {
		this.fetchLatestMessage();
	},
	mounted() {
		// 启动轮播
		this.startCarousel();
	},
	beforeDestroy() {
		// 清除定时器
		this.stopCarousel();
	},
	methods: {
		// 启动轮播
		startCarousel() {
			if (this.totalSlides > 1) {
				this.carouselTimer = setInterval(() => {
					this.currentSlideIndex = (this.currentSlideIndex + 1) % this.totalSlides;
				}, 4000); // 每4秒切换一次
			}
		},
		// 停止轮播
		stopCarousel() {
			if (this.carouselTimer) {
				clearInterval(this.carouselTimer);
				this.carouselTimer = null;
			}
		},
		// 跳转到指定轮播
		goToSlide(index) {
			this.currentSlideIndex = index;
			// 重置定时器
			this.stopCarousel();
			this.startCarousel();
		},
        async fetchList(page = 1, limit = 10) {
			this.listLoading = true;
			try {
				const fd = new FormData();
				fd.append('InputJson', JSON.stringify({ Key: '',Status:'1' }));
				fd.append('PageIndex', page || this.listQuery.page);
				fd.append('PageSize', limit || this.listQuery.limit);

				// 假设 this.$api 已全局挂载
				const res = await this.$api.beyoudsky.GetMessageFileList(fd);
				console.log('API Response:', res);

				if (res.data.errorCode == '1') {
					const { Count = 0, Data = [] } = res.data.data;
                    
                    // 数据映射 Mapping
					this.newsList = Data.map((e) => {
						return {
							id: e.id,
							title: e.title,
                            // 映射 remarks 到 desc
							desc: e.remarks || '暂无简介', 
                            // API如果没有图片字段，使用默认图
							image: this.defaultImage, 
							duration: null, // API暂无时长字段
							categoryName: e.createdBy || '系统消息', // 使用创建人作为分类
							// 简单的日期处理
                            timeAgo: e.createdTime?.includes('T') ? e.createdTime.replace('T', ' ') : e.createdTime,
							views: e.playNums || 0,
                            // 映射 text1 到 videoUrl
                            videoUrl: e.text1 
						};
					});
					this.total = Count || 0;
				} else {
					throw new Error(res.data.msg || '获取数据失败');
				}
			} catch (error) {
				console.error('获取文件列表失败:', error);
				this.$message.error('加载列表失败，请稍后重试');
			} finally {
				this.listLoading = false;
			}
		},
		// 模拟内部接口调用逻辑
		async fetchLatestMessage() {
			try {
				// 模拟网络延迟 500ms
				// await new Promise((resolve) => setTimeout(resolve, 500));
                const fd = new FormData();
				fd.append('InputJson', JSON.stringify({ Key: '' }));
				fd.append('PageIndex', 1);
				fd.append('PageSize', 1);

				// 假设 this.$api 已全局挂载
				const res = await this.$api.beyoudsky.GetMessageFileList(fd);
                if (res.data.errorCode == '1') {
					const {Data = [] } = res.data.data;
                    // 数据映射 Mapping
					if (Data.length > 0) {
						this.message = {
                            ...Data[0],
                            time: Data[0].createdTime?.includes('T') ? Data[0].createdTime.replace('T', ' ') : Data[0].createdTime,
                            description: Data[0].remarks || '',
                        }
					}
				} else {
					throw new Error(res.data.msg || '获取数据失败');
				}

				// 模拟后端返回的数据
				// this.message = {
				// 	id: 101,
				// 	title: '系统更新说明 V2.0 已上线',
				// 	description: '管理员上传了新的视频文件。本次更新包含重要功能修复，请点击下方按钮观看详细说明视频。',
				// 	time: '2分钟前',
				// 	type: 'update',
				// };
			} catch (error) {
				console.error('获取最新消息失败:', error);
			}
		},
		handleWatch() {
			console.log('用户点击了立即观看', this.message.id);
			// TODO: 处理业务逻辑，例如跳转至视频详情页
			this.$router.push({ name: 'MessageNews', params: { id: this.message.id } });
		},
		handleRemind() {
			console.log('用户点击了稍后提醒');
            this.message = null
		},
	},
};
</script>

<style lang="less" scoped>
// 变量定义
@color-pink: #ec4899;
@color-blue: #3b82f6;
@color-indigo: #6366f1;
@color-indigo-dark: #4338ca;
@color-white: #ffffff;
@color-text-indigo-light: #e0e7ff;
@color-btn-hover: #eef2ff;

// 动画定义
@keyframes fadeInDown {
	from {
		opacity: 0;
		transform: translateY(-20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

@keyframes pulse {
	0%,
	100% {
		opacity: 1;
	}
	50% {
		opacity: 0.5;
	}
}

// 轮播切换动画
.slide-fade-enter-active,
.slide-fade-leave-active {
	transition: all 0.6s ease;
}

.slide-fade-enter {
	opacity: 0;
	transform: translateX(30px);
}

.slide-fade-leave-to {
	opacity: 0;
	transform: translateX(-30px);
}

.message-card {
	position: relative;
	max-width: 672px;
	width: 100%;
	aspect-ratio: 16/10;
	border-radius: 16px;
	overflow: hidden;
	box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
	text-align: left;

	&.fade-in-down {
		animation: fadeInDown 0.8s ease-out forwards;
	}

	// 轮播容器
	.carousel-container {
		position: relative;
		width: 100%;
		aspect-ratio: 16/10;
		// min-height: 400px;
		overflow: hidden;

		.carousel-slide {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			// min-height: 400px;
		}

		// 图片轮播项
		.image-slide {
			display: flex;
			align-items: center;
			justify-content: center;
			// background-color: #fff;

			.slide-image {
				width: 100%;
				height: 100%;
				object-fit: contain;
				// object-fit: scale-down;
			}
		}

		// 消息内容轮播项
		.message-slide {
			padding: 24px;
			background-color: rgba(255, 255, 255, 0.1);
			backdrop-filter: blur(16px);
			-webkit-backdrop-filter: blur(16px);
			border: 1px solid rgba(255, 255, 255, 0.2);
			position: relative;

			// 背景装饰圆 Blob
			.blob {
				position: absolute;
				width: 128px;
				height: 128px;
				border-radius: 50%;
				mix-blend-mode: multiply;
				filter: blur(40px);
				opacity: 0.3;
				z-index: 1;
			}

			.blob-pink {
				background-color: @color-pink;
				top: -40px;
				right: -40px;
			}

			.blob-blue {
				background-color: @color-blue;
				bottom: -40px;
				left: -40px;
			}
		}
	}

	// 轮播指示器
	.carousel-indicators {
		position: absolute;
		bottom: 16px;
		left: 50%;
		transform: translateX(-50%);
		display: flex;
		gap: 8px;
		z-index: 20;

		.indicator {
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background-color: rgba(255, 255, 255, 0.5);
			cursor: pointer;
			transition: all 0.3s ease;

			&:hover {
				background-color: rgba(255, 255, 255, 0.8);
			}

			&.active {
				width: 24px;
				border-radius: 4px;
				background-color: @color-white;
			}
		}
	}
}

.card-inner {
	position: relative;
	z-index: 10;
	display: flex;
	align-items: flex-start;
	gap: 16px;
}

// 图标容器
.icon-container {
	flex-shrink: 0;

	.icon-circle {
		width: 48px;
		height: 48px;
		border-radius: 50%;
		background: linear-gradient(to bottom right, @color-pink, @color-indigo);
		display: flex;
		align-items: center;
		justify-content: center;
		color: @color-white;
		box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);

		.bell-icon {
			font-size: 20px;
			animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
		}
	}
}

// 右侧内容区
.content-body {
	flex: 1;

	.meta-info {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 4px;
		font-size: 12px;

		.tag {
			color: #fbcfe8;
			font-weight: 700;
			letter-spacing: 0.05em;
			text-transform: uppercase;
		}

		.time {
			color: #d1d5db;

			svg {
				margin-right: 4px;
			}
		}
	}

	.title {
		font-size: 20px;
		font-weight: 700;
		color: @color-white;
		margin-top: 0;
		margin-bottom: 8px;
		line-height: 1.25;
	}

	.description {
		color: @color-text-indigo-light;
		font-size: 14px;
		margin-bottom: 16px;
		line-height: 1.5;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
	}

	.action-buttons {
		display: flex;
		gap: 12px;

		.btn {
			padding: 8px 16px;
			border-radius: 8px;
			font-size: 14px;
			transition: all 0.2s;
			cursor: pointer;
			border: none;
			outline: none;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.btn-primary {
			background-color: @color-white;
			color: @color-indigo-dark;
			font-weight: 700;
			box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);

			.btn-icon {
				margin-right: 8px;
			}

			&:hover {
				background-color: @color-btn-hover;
			}

			&:active {
				transform: translateY(1px);
			}
		}

		.btn-text {
			background: transparent;
			color: #bfdbfe;
			font-weight: 500;

			&:hover {
				color: @color-white;
			}
		}
	}
}
</style>
